
import {combineReducers} from 'redux';

import changeNotes from './notes.js';

export default combineReducers({
    changeNotes
});

